import { useState, useEffect, useRef } from 'react'
import useOrder from './useOrder'
import useItem from './useItem'
import cloneDeep from 'lodash.clonedeep'

export default function useOrderItem(_locationUUID = null, _orderUUID, _orderItemUUID, _itemUUID = null) {
  const [orderItem, setOrderItem] = useState({})
  const { orderItemsAssembled, updateItem, addItem, addItemStatus, order } = useOrder(_locationUUID, _orderUUID)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(true)
  const orderItemUUID = useRef(null)

  const { item, sizes, assembledItem, selectedSize, takeAway,
    setModifierCount, setSize, setNotes, setCount, setQuantity, setServingID, setTakeAway } = useItem(orderItem?.uuid || _itemUUID, orderItem?.selectedSizeUUID || null, _locationUUID, orderItem, null, order)

  const update = () => {
    let submitItem = cloneDeep(assembledItem)
    submitItem.orderItemUUID = orderItemUUID.current
    //console.log('THE ITEM WE EDITED!', submitItem)
    setOrderItem({ ...submitItem })
    updateItem(submitItem)
    return null
  }

  const duplicate = () => {
    let submitItem = cloneDeep(assembledItem)
    //console.log('THE ITEM WE ADD NEW!', submitItem)
    addItem(submitItem)
    return null
  }

  const addStatus = async (statusID, notes) => {
    let res = await addItemStatus(orderItemUUID.current, statusID, notes)
    return res
  }

  useEffect(() => {
    if (orderItemsAssembled != null) {
      if (_orderItemUUID != null) {
        //console.log(orderItem1)
        if (orderItemsAssembled?.[_orderItemUUID] != null) {
          setOrderItem(cloneDeep(orderItemsAssembled?.[_orderItemUUID]))
          orderItemUUID.current = _orderItemUUID
          setNotFound(false)
          setLoading(false)
        } else {
          setNotFound(true)
        }
      } else {
        // 
      }
    }
  }, [orderItemsAssembled, _orderItemUUID, _itemUUID]);

  return {
    orderItem,
    assembledItem,
    notFound,
    loading,
    item,
    sizes,
    selectedSize,
    takeAway,
    setModifierCount,
    setCount,
    setQuantity,
    setServingID,
    setNotes,
    setSize,
    setTakeAway,
    update,
    duplicate,
    addStatus
  }
}
